import React from 'react';

const TermsAndPrivacy: React.FC = () => {
    return (
        <p className='text-sm text-gray-600 mt-4'>
            By clicking to continue, you are agreeing to our{' '}
            <a
                href='https://puzzleplanet.io/terms?returnUrl=blank'
                target='_blank'
                rel='noopener noreferrer'
                className='text-blue-600 hover:text-blue-800 underline'
            >
                Terms of Service
            </a>{' '}
            and{' '}
            <a
                href='https://puzzleplanet.io/privacy?returnUrl=blank'
                target='_blank'
                rel='noopener noreferrer'
                className='text-blue-600 hover:text-blue-800 underline'
            >
                Privacy Policy
            </a>
            .
        </p>
    );
};

export default TermsAndPrivacy;
